<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="col-12">
    <h2 class="page-title" tabindex="0">{{'profile.edit_picture' | translate}}</h2>
    <div class="col-12 p-0 m-0 mb-2">
        <xng-breadcrumb separator=" > ">
            <ng-container *xngBreadcrumbItem="let breadcrumb">
                <span *ngIf="breadcrumb">
                    {{ 'breadcrumb.' + breadcrumb | translate }}
                    <span *ngIf="isBreadcrumbFinal(breadcrumb)">
                        - {{ user.firstName }} {{ user.lastName }}
                    </span>
                </span>
            </ng-container>
        </xng-breadcrumb>
    </div>
    <div class="container">
        <div class="row justify-content-center">
            <img [src]="picturePreview?picturePreview:'assets/images/default-user.jpeg'" alt="{{'user.profile_picture' | translate}}" class="img-round img-size" />
        </div>
        <div class="row mt-3 justify-content-center">
            <div class="custom-file">
                <input type="file" class="custom-file-input" id="customFileLang" [lang]="lang" title="{{'general.select' | translate}}"
                       (change)="handleProfilePictureUpload($event.target.files)">
                <div class="custom-file-label custom-label" id="fileLabel" title="{{'general.select' | translate}}"></div>
            </div>
        </div>
        <div class="row text-center mt-3">
            <div id="doc-err" class="col-12 error"></div>
        </div>
        <div class="row mt-3 justify-content-center">
            <button type="button" title="{{'general.update' | translate}}" class="btn btn-green btn-h-green btn-width" (click)="saveProfilePicture()" [disabled]="!profilePicture">
                {{'general.update' | translate}}
            </button>
        </div>
        <div class="row mt-3 justify-content-center">
            <button type="button" title="{{'general.delete' | translate}}" class="btn btn-red btn-h-red btn-width" (click)="deleteUserPic()" [disabled]="!pictureExists">
                {{'general.delete' | translate}}
            </button>
        </div>
    </div>
</div>